import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ImagenPerfil from '../../../components/common/ImagenPerfil';
import { FiEdit3, FiCheck, FiX } from 'react-icons/fi';

const FeedCardHeaderInfiniteScroll = ({
    vNombreUsuario,
    vFecha,
    vHora,
    vComentario,
    idTipoComentario,
    vIP,
    comentarioExtra = "",
    idTipoComentarioExtra,
    idOrden,
    idLicencia,
    idUsuario,
    idLeadComentario,
    onEditComment,
    currentUserId,
    procesandoEdicion = false,
    dUpdatedDate
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editText, setEditText] = useState('');
    const [originalText, setOriginalText] = useState('');

    const handleStartEdit = () => {
        // Remover HTML tags para editarlo
        const comentarioLimpio = vComentario.replace(/<[^>]*>/g, '');
        setEditText(comentarioLimpio);
        setOriginalText(comentarioLimpio); // Guardar el texto original
        setIsEditing(true);
    };

    const handleConfirmEdit = async () => {
        // Solo enviar si el texto cambió
        if (editText.trim() !== originalText.trim()) {
            if (onEditComment) {
                await onEditComment(idLeadComentario, editText);
            }
        }
        setIsEditing(false);
        setEditText('');
        setOriginalText('');
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditText('');
        setOriginalText('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleConfirmEdit();
        }
        if (e.key === 'Escape') {
            handleCancelEdit();
        }
    };

    const tipoComentarioBg = {
        1: 'warning',
        2: 'success',
        3: 'info',
        default: 'light'
    };

    const SoftBadgeBgClass = tipoComentarioBg[idTipoComentarioExtra] || tipoComentarioBg.default;
    return (
        <>
            {
                idTipoComentario == 1 ?
                    <>
                        {
                            idTipoComentario == 1 && <hr className="text-200 m-0 mb-0" />
                        }

                        <Row className={"justify-content-between p-2 mb-0"} >
                            <Col className="col-12">
                                <Flex>
                                    <ImagenPerfil idUsuario={idUsuario}></ImagenPerfil>
                                    <div className="flex-1 align-self-center ms-2 mb-0">

                                        <p className="mb-1 lh-1">
                                            <Link className="fw-semi-bold fs--2" to={"/perfil/" + idUsuario}>
                                                {vNombreUsuario}
                                            </Link>  •
                                            <span className="mb-0 fs--1  text-500">
                                                {vIP} • {vFecha} • <img src="/img/reloj48.png" width={15}></img> {vHora}
                                                {/* Mostrar fecha de edición si existe, en la misma línea y formato MM/DD/YYYYhh:mm A */}
                                                {typeof dUpdatedDate !== 'undefined' && dUpdatedDate && (
                                                    <span className="ms-2">
                                                        {[`[Editado: ${new Date(dUpdatedDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}]`]}
                                                    </span>
                                                )}
                                            </span>
                                            {comentarioExtra != "" &&
                                                <Col className="col-2" >
                                                    <Link target="_blank" rel="noopener noreferrer" to={idTipoComentarioExtra == 2 ? "/ordenes/detalle/" + idOrden : "/licencias/detalle/" + idLicencia} >
                                                        <SoftBadge bg={SoftBadgeBgClass} className={"fw-bold fs--2"} >
                                                            {comentarioExtra}
                                                        </SoftBadge>
                                                    </Link>
                                                </Col>
                                            }
                                        </p>

                                        <p className="mb-0  fs--1">
                                            &nbsp;
                                            {isEditing ? (
                                                <div className="d-flex align-items-center">
                                                    <textarea
                                                        className="form-control form-control-sm fs--1"
                                                        value={editText}
                                                        onChange={(e) => setEditText(e.target.value)}
                                                        onKeyDown={handleKeyPress}
                                                        autoFocus
                                                        rows={2}
                                                        style={{ resize: 'none', marginRight: '8px' }}
                                                    />
                                                    <div className="d-flex">
                                                        <button
                                                            className="btn btn-link p-1 text-success"
                                                            onClick={handleConfirmEdit}
                                                            title="Confirmar (Enter)"
                                                            disabled={procesandoEdicion}
                                                        >
                                                            {procesandoEdicion ? '...' : <FiCheck size={16} />}
                                                        </button>
                                                        <button
                                                            className="btn btn-link p-1 text-danger"
                                                            onClick={handleCancelEdit}
                                                            title="Cancelar (Esc)"
                                                            disabled={procesandoEdicion}
                                                        >
                                                            <FiX size={16} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <span>
                                                    <span dangerouslySetInnerHTML={{ __html: vComentario }} />
                                                    {/* Botón de editar solo para comentarios tipo 1 y del usuario actual */}
                                                    {idTipoComentario === 1 && idUsuario === currentUserId && (
                                                        <button
                                                            className="btn btn-link p-0 ms-2 fs--2 text-muted"
                                                            onClick={handleStartEdit}
                                                            title="Editar comentario"
                                                        >
                                                            <FiEdit3 size={14} />
                                                        </button>
                                                    )}
                                                </span>
                                            )}
                                        </p>
                                    </div>

                                </Flex>
                            </Col>

                        </Row>
                    </>
                    :
                    <>
                        <Row className="ps-2 pb-1 ">
                            <Col className="col-12 align-content-center">
                                <Row>
                                    <Col className="col-12 m-0">
                                        <Link className="fw-semi-bold fs--2" to={"/perfil/" + idUsuario}>
                                            🤖 Sistema -- {vNombreUsuario}
                                        </Link>  • {" "}
                                        <span className="mb-0 fs--1  text-500">
                                            {vIP} • {vFecha} • <img src="/img/reloj48.png" width={15}></img> {vHora} • {' '}
                                        </span>
                                    </Col>
                                </Row>
                            </Col>

                            <Col className="col-12 align-self-center">
                                <span className="fs--1">
                                    <span dangerouslySetInnerHTML={{ __html: vComentario }} />
                                </span>
                            </Col>

                        </Row>
                    </>
            }


        </>

    );
};

FeedCardHeaderInfiniteScroll.propTypes = {
    vNombreUsuario: PropTypes.string,
    vFecha: PropTypes.string,
    vHora: PropTypes.string,
    vComentario: PropTypes.string,
    idTipoComentario: PropTypes.number,
    vIP: PropTypes.string,
    idUsuario: PropTypes.number,
    comentarioExtra: PropTypes.string,
    idTipoComentarioExtra: PropTypes.number,
    idOrden: PropTypes.number,
    idLicencia: PropTypes.number,
    idLeadComentario: PropTypes.number,
    onEditComment: PropTypes.func,
    currentUserId: PropTypes.number,
    procesandoEdicion: PropTypes.bool,
    dUpdatedDate: PropTypes.string
};

export default FeedCardHeaderInfiniteScroll;
